// create-friend-gray analytics helpers.
//
// All analytics flows through GTM (window.dataLayer.push) — this lander never
// talks to Mixpanel directly (no SDK / token). The shared GTM container holds
// the Mixpanel token and is configured to forward ONLY `registration_started`
// and `lander_registration_completed` to Mixpanel; every other event below stays
// GTM/GA-only. `lp_source` lets the shared container tell this LP's traffic
// apart from the other landers. Mirrors api.js LP_SOURCE.
const LP_SOURCE = 'createaisexfriend'

export const trackEvent = (eventName, eventParams = {}) => {
  try {
    window.dataLayer = window.dataLayer || []

    // Every event carries `lp_source`. Spread caller params last so an
    // explicit override still wins.
    const eventData = {
      event: eventName,
      lp_source: LP_SOURCE,
      ...eventParams,
      timestamp: new Date().toISOString(),
    }

    window.dataLayer.push(eventData)

    if (process.env.NODE_ENV === 'development') {
      console.log('📊 Analytics Event:', eventName, eventParams)
    }

    return true
  } catch (error) {
    console.error('Analytics tracking error:', error)
    return false
  }
}

export const trackStepComplete = (stepNumber, stepData = {}) => {
  return trackEvent(`step_${stepNumber}`, {
    step_number: stepNumber,
    ...stepData,
  })
}

// First screen — the style pick fires `style_selected` (not a numbered step).
export const trackStyleSelected = (style) => {
  return trackEvent('style_selected', {
    step_name: 'Style',
    style: style,
  })
}

export const trackStep2 = (age, ethnicity) => {
  return trackStepComplete(2, {
    step_name: 'Ethnicity',
    age: age,
    ethnicity: ethnicity,
  })
}

export const trackStep3 = (bodyType, breastSize, buttSize) => {
  return trackStepComplete(3, {
    step_name: 'Body',
    body: bodyType,
    breast: breastSize,
    booty: buttSize,
  })
}

export const trackStep4 = (hairStyle, hairColor, eyeColor) => {
  return trackStepComplete(4, {
    step_name: 'Hair',
    hair_style: hairStyle,
    hair_color: hairColor,
    eye_color: eyeColor,
  })
}

export const trackStep5 = (voice, relationship) => {
  return trackStepComplete(5, {
    step_name: 'Voice',
    voice: voice,
    relationship: relationship,
  })
}

// Final quiz screen — the character reveal view.
export const trackStep6 = () => {
  return trackStepComplete(6, {
    step_name: 'Reveal',
  })
}

// Fires when the registration form (AuthModal) opens.
export const trackRegistrationModalOpened = () => {
  return trackEvent('lander_registration_modal')
}

// Registration attempt started (email submit or Google sign-up). Forwarded to
// Mixpanel by the GTM container.
export const trackRegistrationStarted = (source) => {
  return trackEvent('registration_started', {
    source: source,
  })
}

// Registration succeeded. Forwarded to Mixpanel by the GTM container.
export const trackRegistrationCompleted = (source, email) => {
  return trackEvent('lander_registration_completed', {
    source: source,
    email: email,
  })
}

// Fires on successful email/password login. GTM-only.
export const trackLoginCompleted = () => {
  return trackEvent('lander_login_completed')
}

// Fires after a password reset successfully completes (new password set).
export const trackForgotPasswordCompleted = () => {
  return trackEvent('lander_forgot_pass_completed')
}

export default {
  trackEvent,
  trackStepComplete,
  trackStyleSelected,
  trackStep2,
  trackStep3,
  trackStep4,
  trackStep5,
  trackStep6,
  trackRegistrationModalOpened,
  trackRegistrationStarted,
  trackRegistrationCompleted,
  trackLoginCompleted,
  trackForgotPasswordCompleted,
}
